// extracted by mini-css-extract-plugin
module.exports = {"avatarCard":"avatar-card_avatarCard__11Gdw","avatar":"avatar-card_avatar__Nl14N","username":"avatar-card_username__3pDss","created":"avatar-card_created__3gJVD"};